
const initialState = {
    inventories:[],
    inventoryCountList:[],
    wareHouseTransferList:[],
    inventory_valuation:[],
    salesReport:[],
    profitabilityReport:[]
};


function InventoryReducer(state = initialState, action) {


    if (action.type === "INVENTORIES_LIST") {
        var inventoryDetails = {
            ...state,
            inventories: action.payload
        };
        return inventoryDetails;
    }

    
    if (action.type === "SALES_REPORT") {
        var inventoryDetails = {
            ...state,
            salesReport: action.payload
        };
        return inventoryDetails;
    }
    if (action.type === "INVENTORY_VALUATION") {
        var inventoryDetails = {
            ...state,
            inventory_valuation: action.payload
        };
        return inventoryDetails;
    }
    if (action.type === "PROFITABILITY_REPORT") {
        var inventoryDetails = {
            ...state,
            profitabilityReport: action.payload
        };
        return inventoryDetails;
    }
    
    if (action.type === "INVENTORY_COUNT_LIST") {
        var inventoryDetails = {
            ...state,
            inventoryCountList: action.payload
        };
        return inventoryDetails;
    }

    if (action.type === "WAREHOUSE_TRANSFER_LIST") {
        var inventoryDetails = {
            ...state,
            wareHouseTransferList: action.payload
        };
        return inventoryDetails;
    }

    


    return state;
}

export default InventoryReducer;














